import RequesterV1 from "@/components/api/v1/requester.js";

export default {
  fetchProducer(agro_exporter_id, producer_id) {
    return RequesterV1.get(
      `agro_exporter/certifications/providers/manage_crop_field_certification/${agro_exporter_id}/fetch_producer/${producer_id}`
    );
  },
  fetchCropFieldCertifications(agro_exporter_id, producer_id) {
    return RequesterV1.get(
      `agro_exporter/certifications/providers/manage_crop_field_certification/${agro_exporter_id}/fetch_crop_field_certifications/${producer_id}`
    );
  },
  fetchCertifications(agro_exporter_id, producer_id) {
    return RequesterV1.get(
      `agro_exporter/certifications/providers/manage_crop_field_certification/${agro_exporter_id}/fetch_certifications/${producer_id}`
    );
  },
  fetchCropFields(agro_exporter_id, producer_id) {
    return RequesterV1.get(
      `agro_exporter/certifications/providers/manage_crop_field_certification/${agro_exporter_id}/fetch_crop_fields/${producer_id}`
    );
  },
  fetchCropFieldCertification(
    agro_exporter_id,
    producer_id,
    crop_field_certification_id
  ) {
    return RequesterV1.get(
      `agro_exporter/certifications/providers/manage_crop_field_certification/${agro_exporter_id}/fetch_crop_field_certification/${producer_id}/${crop_field_certification_id}`
    );
  },
  fetchCertificationReviews(agro_exporter_id, producer_id) {
    return RequesterV1.get(
      `agro_exporter/certifications/providers/manage_crop_field_certification/${agro_exporter_id}/fetch_certification_reviews/${producer_id}`
    );
  },
  create(
    agro_exporter_id,
    producer_id,
    crop_field_id,
    crop_field_certification
  ) {
    let formData = new FormData();
    formData.append(
      "crop_field_certification[expiration_date]",
      crop_field_certification.expiration_date
    );
    formData.append(
      "crop_field_certification[certification_id]",
      crop_field_certification.certification_id
    );
    formData.append(
      "crop_field_certification[renewal_date]",
      crop_field_certification.renewal_date
    );
    formData.append(
      "crop_field_certification[active]",
      crop_field_certification.active
    );
    if (crop_field_certification.certificate_file) {
      formData.append(
        "crop_field_certification[certificate_file]",
        crop_field_certification.certificate_file
      );
    }
    return RequesterV1.post(
      `agro_exporter/certifications/providers/manage_crop_field_certification/${agro_exporter_id}/create/${producer_id}/${crop_field_id}`,
      formData
    );
  },
  update(
    agro_exporter_id,
    producer_id,
    crop_field_certification_id,
    crop_field_certification
  ) {
    let formData = new FormData();
    formData.append(
      "crop_field_certification[expiration_date]",
      crop_field_certification.expiration_date
    );
    formData.append(
      "crop_field_certification[certification_id]",
      crop_field_certification.certification_id
    );
    formData.append(
      "crop_field_certification[renewal_date]",
      crop_field_certification.renewal_date
    );
    formData.append(
      "crop_field_certification[active]",
      crop_field_certification.active
    );
    if (crop_field_certification.certificate_file) {
      formData.append(
        "crop_field_certification[certificate_file]",
        crop_field_certification.certificate_file
      );
    }
    return RequesterV1.post(
      `agro_exporter/certifications/providers/manage_crop_field_certification/${agro_exporter_id}/update/${producer_id}/${crop_field_certification_id}`,
      formData
    );
  },
  destroy(agro_exporter_id, producer_id, crop_field_certification_id) {
    return RequesterV1.get(
      `agro_exporter/certifications/providers/manage_crop_field_certification/${agro_exporter_id}/destroy/${producer_id}/${crop_field_certification_id}`
    );
  },
  downloadCertificateFile(agro_exporter_id, producer_id, crop_field_certification_id) {
    return RequesterV1.get(
      `agro_exporter/certifications/providers/manage_crop_field_certification/${agro_exporter_id}/download_certificate_file/${producer_id}/${crop_field_certification_id}`,
      { responseType: "blob" }
    );
  }
};
